export type GameCommand =
  | "start"
  | "left"
  | "right"
  | "softDrop"
  | "hardDrop"
  | "rotateLeft"
  | "rotateRight"
  | "confirm"
  | "cancel"
  | "help"
  | "settings";

const keyCommandMap = new Map<string, GameCommand>([
  ["Space", "hardDrop"],
  ["ArrowUp", "rotateRight"],
  ["KeyW", "rotateRight"],
  ["KeyX", "rotateRight"],
  ["KeyE", "rotateRight"],
  ["KeyZ", "rotateLeft"],
  ["KeyQ", "rotateLeft"],
  ["ArrowLeft", "left"],
  ["KeyA", "left"],
  ["ArrowRight", "right"],
  ["KeyD", "right"],
  ["ArrowDown", "softDrop"],
  ["KeyS", "softDrop"],
  ["Enter", "confirm"],
  ["Escape", "cancel"],
  ["F1", "help"]
]);

export function commandFromKeyboardEvent(event: KeyboardEvent): GameCommand | null {
  return keyCommandMap.get(event.code) ?? null;
}

export function isGameplayKey(event: KeyboardEvent): boolean {
  return keyCommandMap.has(event.code);
}

export interface GamepadCommandState {
  command: GameCommand;
  pressed: boolean;
}

export function commandsFromGamepad(gamepad: Gamepad): GamepadCommandState[] {
  const buttons = gamepad.buttons;
  const leftAxis = gamepad.axes[0] ?? 0;
  const verticalAxis = gamepad.axes[1] ?? 0;
  return [
    { command: "left", pressed: Boolean(buttons[14]?.pressed) || leftAxis < -0.55 },
    { command: "right", pressed: Boolean(buttons[15]?.pressed) || leftAxis > 0.55 },
    { command: "softDrop", pressed: Boolean(buttons[13]?.pressed) || verticalAxis > 0.55 },
    { command: "hardDrop", pressed: Boolean(buttons[12]?.pressed) || verticalAxis < -0.55 },
    { command: "rotateRight", pressed: Boolean(buttons[0]?.pressed) },
    { command: "rotateLeft", pressed: Boolean(buttons[1]?.pressed) },
    { command: "confirm", pressed: Boolean(buttons[9]?.pressed) },
    { command: "cancel", pressed: Boolean(buttons[8]?.pressed) }
  ];
}
